// Controles compartidos de estilo/grosor de línea para EMA/SMA Quantum —
// mismo lenguaje visual que StyleSelect de vwap/Panel.jsx (grupo de botones
// segmentados, tokens Quantum), NUNCA controles nativos (<select>, <input
// type="range">). Usados en el formulario de edición de fila (Panel.jsx),
// el formulario inline de Badge.jsx y los acordeones +EMA/+SMA de Badge.jsx.
import { LINE_STYLES, MIN_LINE_WIDTH, MAX_LINE_WIDTH } from './constants.js'

const STYLE_LABELS = { solid: 'Sólida', dashed: 'Discontinua', dotted: 'Punteada' }
const WIDTHS = Array.from({ length: MAX_LINE_WIDTH - MIN_LINE_WIDTH + 1 }, (_, i) => MIN_LINE_WIDTH + i)

const DASH_ARRAY = { solid: undefined, dashed: '5,3', dotted: '1.5,3' }

// Muestra visual de la línea (color + estilo + grosor reales) — usada en el
// badge para que cada media se identifique de un vistazo, y en el panel
// junto al selector para preview inmediato del cambio.
export function LineSwatch({ color, lineStyle = 'solid', lineWidth = 2, width = 36, height = 12 }) {
  const y = height / 2
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" style={{ flexShrink: 0 }}>
      <line
        x1={1} y1={y} x2={width - 1} y2={y}
        stroke={color}
        strokeWidth={lineWidth}
        strokeDasharray={DASH_ARRAY[lineStyle]}
        strokeLinecap={lineStyle === 'dotted' ? 'round' : 'butt'}
      />
    </svg>
  )
}

export function LineStyleSelect({ value, onChange, compact = false }) {
  return (
    <div className={`grid grid-cols-3 ${compact ? 'gap-1' : 'gap-1.5'}`}>
      {LINE_STYLES.map((style) => (
        <button
          key={style}
          type="button"
          onClick={() => onChange(style)}
          title={STYLE_LABELS[style]}
          className={`flex items-center justify-center rounded border transition-colors ${compact ? 'py-1' : 'py-1.5 px-2'} ${
            value === style
              ? 'bg-[var(--paper,#FDFDFA)] border-[var(--gold,#B08D57)]'
              : 'bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-700 hover:bg-slate-50 dark:hover:bg-gray-700'
          }`}
        >
          <svg width={compact ? 20 : 28} height={8} viewBox={`0 0 ${compact ? 20 : 28} 8`} aria-hidden="true">
            <line
              x1={1} y1={4} x2={(compact ? 20 : 28) - 1} y2={4}
              stroke={value === style ? 'var(--green-deep,#0B3D2E)' : 'currentColor'}
              className={value === style ? '' : 'text-slate-500 dark:text-gray-400'}
              strokeWidth={2}
              strokeDasharray={DASH_ARRAY[style]}
              strokeLinecap={style === 'dotted' ? 'round' : 'butt'}
            />
          </svg>
        </button>
      ))}
    </div>
  )
}

export function LineWidthSelect({ value, onChange, compact = false }) {
  return (
    <div className={`grid grid-cols-4 ${compact ? 'gap-1' : 'gap-1.5'}`}>
      {WIDTHS.map((w) => (
        <button
          key={w}
          type="button"
          onClick={() => onChange(w)}
          title={`${w}px`}
          className={`flex items-center justify-center rounded border transition-colors ${compact ? 'py-1 text-[9px]' : 'py-1.5 text-[11px]'} font-medium ${
            value === w
              ? 'bg-[var(--paper,#FDFDFA)] border-[var(--gold,#B08D57)] text-[var(--green-deep,#0B3D2E)]'
              : 'bg-white dark:bg-gray-800 border-slate-200 dark:border-gray-700 text-slate-600 dark:text-gray-400 hover:bg-slate-50 dark:hover:bg-gray-700'
          }`}
        >
          {w}
        </button>
      ))}
    </div>
  )
}
